import type { ICountry } from '@dakedake/types'
import { useCallback, useState } from 'react'
import { countryList } from '@/services'

export default function useCountry() {
  const [country, setCountry] = useState<ICountry[]>([])

  const getCountryList = useCallback(async () => {
    const res = await countryList({ current: 1, pageSize: 10000 })
    setCountry(res.data?.list || [])
  }, [])

  return {
    country,
    getCountryList
  }
}
